<template>
  <div
    ref="scrollContainer"
    class="favorites-screen"
    @scroll.passive="loadNextOnScroll"
  >
    <header class="favorites-header">
      <button
        class="back"
        @click="goBack"
      >
        <van-icon name="arrow-left" />
      </button>
      <h1>{{ $t('shop.favorites') }}</h1>
    </header>
    <main>
      <van-list
        v-if="!empty"
        v-model="loading"
        :finished="!hasMore"
        finished-text=""
        :loading-text="$t('utils.loading')"
        @load="load"
      >
        <article
          v-for="item in list"
          :key="item.product_id"
          class="favorite-card"
          @click="openProduct(item.product_id)"
        >
          <img
            :src="item.product.image"
            :alt="item.product.title"
          >
          <div class="favorite-info">
            <p>{{ item.product.title }}</p>
            <del v-if="item.product.market_price">{{ money(item.product.market_price) }}</del>
            <strong>{{ money(item.product.price) }}</strong>
          </div>
          <button
            class="remove-favorite"
            :aria-label="$t('shop.removeFavorite')"
            :disabled="removingProductId === item.product_id"
            @click.stop="removeFavorite(item)"
          >
            <van-icon name="like" />
          </button>
        </article>
      </van-list>
      <van-empty
        v-if="empty"
        :description="$t('shop.favoritesEmpty')"
      />
    </main>
  </div>
</template>

<script>
import Vue from 'vue';
import { Empty, List } from 'vant';
import Fetch from '@/utils/fetch';

Vue.use(Empty).use(List);

export default {
    name: 'Favorites',
    data() {
        return {
            list: [], page: 1, hasMore: true, loading: false, requesting: false, empty: false, removingProductId: 0
        };
    },
    mounted() {
        this.$parent.footer('user', false);
        this.load();
    },
    methods: {
        money(value) {
            return this.$formatPen(value);
        },
        goBack() {
            this.$router.push('/user');
        },
        load() {
            if (this.requesting || !this.hasMore) {
                this.loading = false;
                return;
            }
            this.requesting = true;
            this.loading = true;
            Fetch('/shop/favoriteList', { page: this.page, page_size: 20 }, null, true).then((res) => {
                const pageList = (res.data && res.data.list) || [];
                this.list = this.list.concat(pageList);
                this.hasMore = !!(res.data && res.data.has_more) && pageList.length > 0;
                this.empty = this.list.length === 0;
                this.page += 1;
            }).finally(() => {
                this.requesting = false;
                this.loading = false;
                this.$nextTick(() => this.loadNextOnScroll());
            });
        },
        loadNextOnScroll() {
            const container = this.$refs.scrollContainer;
            if (!container) return;
            if (container.scrollTop + container.clientHeight >= container.scrollHeight - 160) {
                this.load();
            }
        },
        openProduct(productId) {
            this.$router.push('/good/' + productId);
        },
        removeFavorite(item) {
            if (this.removingProductId) return;
            this.removingProductId = item.product_id;
            Fetch('/shop/favoriteSet', {
                product_id: item.product_id,
                favorite: 0
            }, null, true).then(() => {
                this.list = this.list.filter((entry) => entry.product_id !== item.product_id);
                this.empty = this.list.length === 0;
                this.$toast(this.$t('shop.favoriteRemoved'));
                if (this.empty && this.hasMore) {
                    this.load();
                }
            }).finally(() => {
                this.removingProductId = 0;
            });
        }
    }
};
</script>

<style scoped>
.favorites-screen { box-sizing: border-box; height: 100vh; overflow-y: auto; -webkit-overflow-scrolling: touch; background: #f5f5f5; color: #333; }
.favorites-header { position: relative; display: flex; height: 50px; align-items: center; justify-content: center; border-bottom: 1px solid #eee; background: #fff; }
.favorites-header h1 { margin: 0; color: #333; font-size: 16px; font-weight: 500; }
.back { position: absolute; left: 16px; display: inline-flex; width: 36px; height: 36px; align-items: center; justify-content: flex-start; padding: 0; border: 0; background: transparent; color: #ee4d2d; font-size: 20px; }
.favorite-card { position: relative; display: flex; min-height: 112px; align-items: center; gap: 12px; margin-bottom: 10px; padding: 12px 52px 12px 14px; background: #fff; }
.favorite-card > img { width: 82px; height: 88px; flex: 0 0 82px; object-fit: contain; }
.favorite-info { min-width: 0; }
.favorite-info p { display: -webkit-box; margin: 0 0 7px; overflow: hidden; color: #333; font-size: 13px; line-height: 18px; -webkit-box-orient: vertical; -webkit-line-clamp: 2; }
.favorite-info del { display: block; margin-bottom: 3px; color: #929aa3; font-size: 11px; }
.favorite-info strong { color: #ee4d2d; font-size: 15px; font-weight: 600; }
.remove-favorite { position: absolute; top: 50%; right: 15px; display: inline-flex; width: 32px; height: 32px; align-items: center; justify-content: center; margin-top: -16px; padding: 0; border: 0; background: transparent; color: #ee4d2d; font-size: 21px; }
.remove-favorite:disabled { opacity: .5; }
</style>
